import {
    ICSIDUserStatusState,
    CSID_REQUEST_USER_STATUS,
    CSID_RESPONSE_USER_STATUS,
    CSIDUserStatusActions,
    ICSIDUserStatus,
    CSID_SSN_PINNING_STATUS,
    CSID_REFRESHING_USER_STATUS,
    SET_GLOBAL_QUESTION_TRY_COUNT,
    SET_GLOBAL_TU_OTP_TRY_COUNT,
    SET_GLOBAL_TU_OTP_REQUESTED_COUNT,
} from "./types";

const initialState: ICSIDUserStatusState = {
    isLoading: false,
    csidUserStatus: {} as ICSIDUserStatus,
    isSSNPinning: false,
    refreshingCSIDUserStatus: false,
    globalQuestionTryCount: 1,
    globalTUOTPTryCount: 0,
    globalTUOTPRequestedCount: 0,
};

export function CSIDUserStatusReducer(state = initialState, action: CSIDUserStatusActions): ICSIDUserStatusState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case CSID_REQUEST_USER_STATUS:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case CSID_RESPONSE_USER_STATUS:
            return {
                ...state,
                csidUserStatus: action.csidUserStatus,
            };
        case CSID_SSN_PINNING_STATUS:
            return {
                ...state,
                isSSNPinning: action.isSSNPinning,
            };
        case CSID_REFRESHING_USER_STATUS:
            return {
                ...state,
                refreshingCSIDUserStatus: action.refreshingCSIDUserStatus,
            };
        case SET_GLOBAL_QUESTION_TRY_COUNT:
            return {
                ...state,
                globalQuestionTryCount: action.globalQuestionTryCount,
            };
        case SET_GLOBAL_TU_OTP_TRY_COUNT:
            return {
                ...state,
                globalTUOTPTryCount: action.globalTUOTPTryCount,
            };
        case SET_GLOBAL_TU_OTP_REQUESTED_COUNT:
            return {
                ...state,
                globalTUOTPRequestedCount: action.globalTUOTPRequestedCount,
            };
        default:
            return state;
    }
}
